import { createAsyncThunk } from "@reduxjs/toolkit";
import * as UserServiceApi from "apis/UserServiceApi";
import { setVolunteers } from "./volunteers.slice";

import { ThunkAPI } from "store/types";

export const fetchVolunteers = createAsyncThunk<
  void,
  void,
  ThunkAPI
>(
  "volunteers/fetchVolunteers",
  async (_, thunkAPI) => {
    try {
      const response = await UserServiceApi.getVolunteers();
      thunkAPI.dispatch(setVolunteers(response.data));
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      return thunkAPI.rejectWithValue(err.response?.data?.error || "Failed to fetch volunteers");
    }
  }
);